import SingleAssMark from "./SingleAssMark";


export default function AssignmentMarkTable({ assignmentMark }) {
    const content = assignmentMark.map(item => <SingleAssMark key={item.id} assignment={item} />)
    return (
        <table className="divide-y-1 text-base divide-gray-600 w-full">

            <thead>
                <tr>
                    <th className="table-th">Assignment</th>
                    <th className="table-th">Date</th>
                    <th className="table-th">Student Name</th>
                    <th className="table-th">Repo Link</th>
                    <th className="table-th">Mark</th>
                </tr>
            </thead>

            <tbody className="divide-y divide-slate-600/50">
                {assignmentMark.length ? content :
                    <tr>
                        <td className="table-td">
                        </td>
                        <td className="table-td">
                        </td>
                        <td className="table-td">
                            <span className="text-yellow-500">No Content found!</span>
                        </td>
                        <td className="table-td">
                        </td>
                        <td className="table-td">
                        </td>
                    </tr>}
            </tbody>

        </table>
    )
};